import { useIntercom } from 'react-use-intercom';
import styled, { createGlobalStyle } from 'styled-components';

import theme from '../../../assets/theme';
import { useIsDesktop } from '../../../hooks/useIsDesktop';
import { Button } from '../Button';

export const CustomIntercomButton = ({ icon }: { icon: React.ReactElement }) => {
  const { showNewMessages } = useIntercom();

  const isDesktop = useIsDesktop();

  return (
    <>
      <GlobalStyles />
      {isDesktop && (
        <StyledIntercomButton icon={icon} onClick={() => showNewMessages()} />
      )}
    </>
  );
};

export default CustomIntercomButton;

const GlobalStyles = createGlobalStyle`
  .intercom-lightweight-app-launcher {
    display: none !important;
  }


  `;

const StyledIntercomButton = styled(Button)`
  background-color: ${theme.colors.paleBeige};
  color: ${theme.colors.black};
  padding: 10px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
  position: fixed;
  bottom: 20px;
  right: 20px;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  box-shadow: ${theme.effects.magicFloatingShadow};

  svg {
    margin: 0;
  }

  &:hover,
  &:focus,
  &:active {
    background-color: ${theme.colors.greyLight};
    color: ${theme.colors.black};
    box-shadow: ${theme.effects.defaultShadow};
  }
`;
